import React, { Component } from "react";
import { withRouter } from "react-router";
import RecommendFlow from "../../../../../CommonComponents/RecommendFlow/RecommendFlow";
import { OneTimeExchangeStep1, TIffStep2 } from "./InfoRectangle/InfoRectangle";
import TIFFTypeSelection from "./TIFFTypeSelection";
import Notice from "../../../../Contributions/Pages/MakeAContribution/Components/CommonComponents/Notice/Notice";
import TIFFRecommendAnExchangeStep2 from "./TiffRecommendAnExchangeStep2";
import Review from "./Review";
import { ContentProvider, Types } from "../../../../../CommonComponents/ContentMessages";
class TIFFRecommendAnExchange extends Component {
  state = {
    stepConfig: [
      {
        key: 1,
        route: "/edit-tiff",
        description: "Recommend exchange from",
        stepContent: () => {
          const {
            valueTiffExchangeAmount,
            totalAmountIntoPool,
            poolCount
          } = this.props.poolTableInto;
          const { selectedTiffOption } = this.props;
          return (
            <OneTimeExchangeStep1
              amountFrom={valueTiffExchangeAmount}
              type={selectedTiffOption}
              amountTo={totalAmountIntoPool}
              poolCount={poolCount}
            />
          );
        },
        mainContent: () => (
          <TIFFTypeSelection
            setExchangeIntoTiff={this.props.setExchangeIntoTiff}
            investmentPools={this.props.accDataPools.investmentPools}
            updateStepper={this.updateStepper}
            stepConfig={this.state.stepConfig}
            dataStepOne={this.props.poolTableInto}
            tiffBalanceAmount={this.props.tiffExchangeAmount}
            tiffPoolName={this.props.tiffPoolName}
            stepOneSet={this.props.stepOneSet}
            availableBalance={this.props.availableBalance}
            resetFlow={this.props.resetFlow}
            firstTiffExchnageFlag={this.props.accDataPools.firstTiffExchnage}
            accDataLoading= {this.props.accDataLoading}
            isEdit={true}
            {...this.props}
          />
        )
      },
      {
        key: 2,
        route: "/edit-tiff/to",
        description: "Recommend exchange to",
        stepContent: () => {
          const { poolCount } = this.props.poolTableFrom;
          const { valueTiffExchangeAmount } = this.props.poolTableInto;
          return (
            <TIffStep2
              poolCount={poolCount}
              valueTiffExchangeAmount={valueTiffExchangeAmount}
            />
          );
        },
        mainContent: () => (
          <TIFFRecommendAnExchangeStep2
            requestAllPoolDataTiff={this.props.requestAllPoolDataTiff}
            requestDataTiff={this.props.requestDataTiff}
            poolData={this.props.allPoolData}
            loading={this.props.allPoolLoading}
            stepOneData={this.props.poolTableInto}
            stepTwoData={this.props.poolTableFrom}
            tiffPoolName={this.props.tiffPoolName}
            stepTwoSet={this.props.stepTwoSet}
            poolDataModal={this.props.poolData}
            poolUf={this.props.poolUf}
            poolModal={this.props.poolModal}
            modalUF={this.props.modalUF}
            setPoolModalFalse={this.props.setPoolModalFalse}
            requestPoolData={this.props.requestPoolData}
            requestunderlyingFunds={this.props.requestunderlyingFunds}
            setPoolModalFalse={this.props.setPoolModalFalse}
            setStepTwo={this.props.setStepTwo}
            resetFlow={this.props.resetFlow}
            {...this.props}
          />
        )
      },
      {
        key: 3,
        route: "/investments/recommend-an-exchange-tiff/review",
        description: "Review exchange & submit",
        mainContent: () => (
          <Review
            selectedTiffOption={this.props.selectedTiffOption}
            poolDataInto={this.props.poolTableInto}
            poolDataFrom={this.props.poolTableFrom}
            tiffFormInfo={this.props.tiifInfoData}
            getTiffDisclaimer={this.props.getTiffDisclaimer}
            tiffDisclaimer={this.props.tiffDisclaimer}
            tiffPoolName={this.props.tiffPoolName}
            resetFlow={this.props.resetFlow}
            {...this.props}
          />
        )
      }
    ]
  };

  updateStepper = tiffType => {
    // TODO: can simplify this.  Debugging on splice ended up like this
    let { stepConfig } = this.state;
    if (tiffType === "exchangeFromTIFF") {
      if (stepConfig.length === 3) return;
      stepConfig.splice(1, 0, this.backUpStep2);
    } else {
      if (stepConfig.length === 2) return;
      [, this.backUpStep2] = stepConfig;
      stepConfig.splice(1, 1);
    }
    stepConfig = stepConfig.map((config, i) => {
      const retConfig = config;
      retConfig.key = i + 1;
      return retConfig;
    });
    this.setState({ stepConfig });
  };
  tabsConfig = () => ({
    extraContent: "Select Schedule Type",
    tabConfig: [
      {
        title: "One Time Exchange",
        key: "oneTime",
        pathname: "/recommendAnExchange/recommendAnExchangeFrom"
      },
      {
        title: "Recurring Exchange",
        key: "recurring",
        pathname: "/recommendAnExchange/recommendAnExchangeFrom"
      },
      {
        title: "TIFF Exchange",
        key: "tiff",
        pathname: "recommendAnExchange/recommendAnExchangeFromTIFF"
      }
    ]
  });
  breadcrumbRoutes = () => [
    {
      routeName: "Home",
      path: "/"
    },
    {
      routeName: "Investments",
      path: "/investments"
    },
    {
      routeName: "Recommend an exchange",
      path: ""
    }
  ];

  beforeMainContent = () => (
    <Notice
      noticeSubject="Disclaimer for TIFF Exchanges: "
      message="Lorem ipsum dolor sit amet, consectetur adipiscing elit, consectetur adipiscing."
    />
  );
  
  componentWillMount(){
    this.props.editMode(this.props.location.params.option);
  }
  componentWillUnmount() {
    this.props.resetFlow();
  }

  render = () => {
    const {
      accountId,
      accountName,
      availableBalance,
      currentBalance,
      requestData,
      tabExchange,
      history
    } = this.props;

    return (
      <ContentProvider types={[Types.PAGE_TITLE_DESCRIPTION]} pages={['Tiff Exchange']}>
        <RecommendFlow
          requestData={requestData}
          accData={{
            accountId,
            accountName,
            availableBalance,
            currentBalance
          }}
          editMode
          handleTabChange={tabExchange}
          breadcrumbRoutes={this.breadcrumbRoutes()}
          stepConfig={this.state.stepConfig}
          pageHeader="Tiff Exchange"
          history={history}
          featureCode="RAE"
        />
        </ContentProvider>
    );
  };
}

export default withRouter(TIFFRecommendAnExchange);
